import { LanguageType } from '@/interface/enum';
import { i18n } from '@/libraries/i18n';

export function capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function invertCapitalize(str: string): string {
    return str.charAt(0).toLowerCase() + str.slice(1);
}

function isSupportLocales() {
    try {
        'foo'.localeCompare('bar', 'i');
        return true;
    } catch (e) {
        return (e as Error).name === 'RangeError';
    }
}

export function getLocalesSortingFn() {
    if (!isSupportLocales()) {
        return (a: string, b: string) => a.localeCompare(b);
    }

    const mapping: Record<LanguageType, string> = {
        [LanguageType.EN]: 'en',
        [LanguageType.TH_TH]: 'th-TH',
        [LanguageType.VI_VN]: 'vi-VN',
        [LanguageType.ZH_CN]: 'zh-Hans',
        [LanguageType.ID_ID]: 'id-ID',
        [LanguageType.JA_JP]: 'ja-JP',
        [LanguageType.KO_KR]: 'ko-KR',
        [LanguageType.MY_MM]: 'my-MM',
        [LanguageType.PT_BR]: 'pt-br',
        [LanguageType.KM_KH]: 'km-KH',
        [LanguageType.HI_IN]: 'hi-IN',
        [LanguageType.TA_IN]: 'ta-IN',
        [LanguageType.BN_BD]: 'bn-BD',
        [LanguageType.MS_MY]: 'ms-MY',
    };

    const locale = mapping[i18n.locale.value] ?? 'en';
    return (a: string, b: string) => a.localeCompare(b, locale);
}
